import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction } from "../../../../library/layout/Index";

const AlarmHeaderViewer = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Alarm Detail' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <div  className="uiEditableContent" id="editor">
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} value="Alarm ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docId" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "activateAlarm" }} value="Is Active" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "activateAlarm" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmTitle" }} value="Alarm Title" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmTitle" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} value="Target Document" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmProcessMethod" }} value="Processing Method" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmProcessMethod" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmSubscriberCode" }} value="Subscriber Code" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmSubscriberCode" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "enableSkipCriteria" }} value="Enable Skip Condition" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "enableSkipCriteria" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "copyOwner" }} value="Notify Owner" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "copyOwner" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "attachToTask" }} value="Attach to Task" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "attachToTask" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerSmsTpl" }} value="Owner SMS TPL" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ownerSmsTpl" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerEmailSub" }} value="Owner Email Sub" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ownerEmailSub" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerEmailTpl" }} value="Owner Email TPL" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ownerEmailTpl" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmReportTpl" }} value="Report Template" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmReportTpl" }} className="uiVal" />
                        </li>
                    </ul>
                </div>
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmFrequency" }} value="Alarm Frequency" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmFrequency" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmFrequencyUnit" }} value="Unit" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmFrequencyUnit" }} className="uiVal" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} value="on" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "whichDayOfFrequency" }} className="uiVal" />
                            <span className="uiSpacerH5">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} value="day" />
                            </span>
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} value="@ Time (24 hrs with Offset)" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "alarmTime" }} className="uiVal" />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} className="uiVal" />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "sFrequencyContainer" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sRRFrequency" }} value="Show Frequency" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sRRFrequency" }} className="uiVal" />


                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sRRFrequencyUnit" }} value="Unit" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sRRFrequencyUnit" }} className="uiVal" />
                            
                            <SarasTrans value ="For Repeat Record" />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "nFrequencyContainer" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nRRFrequency" }} value="Notify Frequency" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nRRFrequency" }} className="uiVal" />


                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nRRFrequencyUnit" }} value="Unit" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nRRFrequencyUnit" }} className="uiVal" />
                            
                            <SarasTrans value ="For Repeat Record" />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "notifyParty" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notifyParty" }} value="Notify Party" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "notifyParty" }} className="uiVal" />

                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "partySmsTpl" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partySmsTpl" }} value="Party SMS TPL" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "partySmsTpl" }} className="uiVal" />

                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "partyEmailSub" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partyEmailSub" }} value="Party Email Sub" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "partyEmailSub" }} className="uiVal" />

                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partyEmailTpl" }} value="Party Email TPL" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "partyEmailTpl" }} className="uiVal" />
                        </li>
                    </ul>
                </div>
            </div>
        </UiView>
    )
}

export default withView(AlarmHeaderViewer, "alarmHeader", "alarmCriteria")
